import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text, Button, Icon } from '../Elements';

import classes from './Tag.module.scss';

const Tag = ({ tag, onClick, areaLabel, className }) => {
  return (
    <div className={cn(classes.tag, className && className)}>
      <Text className={classes.text}>{tag}</Text>
      {onClick && (
        <Button
          className={classes.close}
          onClick={onClick}
          aria-label={areaLabel}
        >
          <Icon icon="closeCircle" size="12px" className={classes.icon} />
        </Button>
      )}
    </div>
  );
};

Tag.propTypes = {
  tag: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  areaLabel: PropTypes.string,
  className: PropTypes.string
};

export default Tag;
